import React from "react";
import ASingleLambdaTestLive from "./aSingleLambdaTestLive";

const ResultsCountsProgramming = ({ show, assessmentInformation, tests, testsConfigDict }) => {    
    const currentCounts = assessmentInformation?.resultsCountsProgramming;

    return (
        <>
            {
                tests && show && (
                    <div className="lambda-results-container" style={{ marginTop: "0px", width: "100%", rowGap: "10px" }}>
                        {
                            !assessmentInformation.pollMode && (
                                <div>
                                    <span className="required">*</span> The test results below will update live in poll mode only
                                </div>
                            )
                        }                       
                        {                
                            tests.map((testUuid) => {
                                if (currentCounts && testUuid in currentCounts) {
                                    return <ASingleLambdaTestLive key={testUuid} count={currentCounts[testUuid]} name={testsConfigDict[testUuid]?.name}/>
                                } else {
                                    return <ASingleLambdaTestLive key={testUuid} count={0} name={testsConfigDict[testUuid]?.name}/>
                                }
                            })
                        }
                    </div>
                )
            }
        </>
    );
}

export default ResultsCountsProgramming;